'use client';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import Spacer from 'Components/Spacer';
import { Typography } from 'Components/Typography';

import { UserReviewsTab } from './UserReviewsTab';

const UserReviewWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 790px;
  padding: ${`${legacyTheme.spacing.s72} ${legacyTheme.spacing.s24}`};

  background: ${theme.colors.neutral[100]};

  ${legacyTheme.breakpoints.up('sm')} {
    padding: ${legacyTheme.spacing.s144} 2em;
  }
`;

const SkincareTitle = styled(Typography)`
  margin: 0px !important;

  ${legacyTheme.breakpoints.up('md')} {
    text-align: center;
  }
`;

const Separator = styled.div`
  width: 20px;
  height: 0.5px;
  margin: 15px 0px;

  background-color: black;

  ${legacyTheme.breakpoints.up('md')} {
    text-align: center;
  }
`;

const SeparatorContainer = styled.div`
  display: flex;

  ${legacyTheme.breakpoints.up('md')} {
    justify-content: center;
  }
`;

const ComingSoonText = styled(Typography)`
  color: ${theme.colors.accent[300]};

  ${legacyTheme.breakpoints.up('md')} {
    text-align: center;
  }
`;

export const UserReviews = () => {
  return (
    <UserReviewWrapper data-testid="reviews-user-reviews-block">
      <SkincareTitle align="left" color="noir" markupName="h2" paragraph variant="mono1">
        The reviews are in
      </SkincareTitle>
      <SeparatorContainer>
        <Separator />
      </SeparatorContainer>

      <ComingSoonText align="left" markupName="h3" paragraph variant="mono1">
        What people are saying:
      </ComingSoonText>
      <Spacer size={32} />
      <UserReviewsTab />
      <Spacer size={56} />
    </UserReviewWrapper>
  );
};
